import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import ChunkErrorBoundary from "./components/ui/ChunkErrorBoundary";
import { checkAndReloadOnVersionChange } from "./hooks/useAppVersionCheck";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <ChunkErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </ChunkErrorBoundary>,
  // </React.StrictMode>
);

checkAndReloadOnVersionChange();
